// ! This file was auto-generated by @rtk-query/codegen-openapi. Do not override this file.

import { api } from "~/redux/api/hermes/codegenApi";
const injectedRtkApi = api.injectEndpoints({
    endpoints: (build) => ({
        healthzHealthzGet: build.query<HealthzHealthzGetApiResponse, HealthzHealthzGetApiArg>({
            query: () => ({ url: `/healthz` }),
        }),
        createConversationEndpointV1ConversationsPost: build.mutation<CreateConversationEndpointV1ConversationsPostApiResponse, CreateConversationEndpointV1ConversationsPostApiArg>({
            query: (queryArg) => ({
                url: `/v1/conversations`,
                method: "POST",
                body: queryArg.createConversationRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        listConversationsEndpointV1ConversationsGet: build.query<ListConversationsEndpointV1ConversationsGetApiResponse, ListConversationsEndpointV1ConversationsGetApiArg>({
            query: (queryArg) => ({
                url: `/v1/conversations`,
                params: {
                    limit: queryArg.limit,
                    cursor: queryArg.cursor,
                    workflow_id: queryArg.workflowId,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getConversationEndpointV1ConversationsConversationIdGet: build.query<GetConversationEndpointV1ConversationsConversationIdGetApiResponse, GetConversationEndpointV1ConversationsConversationIdGetApiArg>({
            query: (queryArg) => ({
                url: `/v1/conversations/${queryArg.conversationId}`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        deleteConversationEndpointV1ConversationsConversationIdDelete: build.mutation<DeleteConversationEndpointV1ConversationsConversationIdDeleteApiResponse, DeleteConversationEndpointV1ConversationsConversationIdDeleteApiArg>({
            query: (queryArg) => ({
                url: `/v1/conversations/${queryArg.conversationId}`,
                method: "DELETE",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        listMessagesEndpointV1ConversationsConversationIdMessagesGet: build.query<ListMessagesEndpointV1ConversationsConversationIdMessagesGetApiResponse, ListMessagesEndpointV1ConversationsConversationIdMessagesGetApiArg>({
            query: (queryArg) => ({
                url: `/v1/conversations/${queryArg.conversationId}/messages`,
                params: { limit: queryArg.limit, cursor: queryArg.cursor },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        postMessageEndpointV1ConversationsConversationIdMessagesPost: build.mutation<PostMessageEndpointV1ConversationsConversationIdMessagesPostApiResponse, PostMessageEndpointV1ConversationsConversationIdMessagesPostApiArg>({
            query: (queryArg) => ({
                url: `/v1/conversations/${queryArg.conversationId}/messages`,
                method: "POST",
                body: queryArg.createMessageRequest,
                headers: {
                    accept: queryArg.accept,
                    "User-Timezone": queryArg["User-Timezone"],
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        createFeedbackEndpointV1ConversationsConversationIdFeedbackPost: build.mutation<CreateFeedbackEndpointV1ConversationsConversationIdFeedbackPostApiResponse, CreateFeedbackEndpointV1ConversationsConversationIdFeedbackPostApiArg>({
            query: (queryArg) => ({
                url: `/v1/conversations/${queryArg.conversationId}/feedback`,
                method: "POST",
                body: queryArg.createFeedbackRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        createUploadEndpointV1ConversationsConversationIdUploadsPost: build.mutation<CreateUploadEndpointV1ConversationsConversationIdUploadsPostApiResponse, CreateUploadEndpointV1ConversationsConversationIdUploadsPostApiArg>({
            query: (queryArg) => ({
                url: `/v1/conversations/${queryArg.conversationId}/uploads`,
                method: "POST",
                body: queryArg.bodyCreateUploadEndpointV1ConversationsConversationIdUploadsPost,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        createBuildEndpointV1ConversationsConversationIdBuildsPost: build.mutation<CreateBuildEndpointV1ConversationsConversationIdBuildsPostApiResponse, CreateBuildEndpointV1ConversationsConversationIdBuildsPostApiArg>({
            query: (queryArg) => ({
                url: `/v1/conversations/${queryArg.conversationId}/builds`,
                method: "POST",
                body: queryArg.submitBuildRequest,
                headers: { "User-Timezone": queryArg["User-Timezone"] },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getBuildEndpointV1ConversationsConversationIdBuildsBuildIdGet: build.query<GetBuildEndpointV1ConversationsConversationIdBuildsBuildIdGetApiResponse, GetBuildEndpointV1ConversationsConversationIdBuildsBuildIdGetApiArg>({
            query: (queryArg) => ({
                url: `/v1/conversations/${queryArg.conversationId}/builds/${queryArg.buildId}`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        cancelBuildEndpointV1ConversationsConversationIdBuildsBuildIdCancelPost: build.mutation<CancelBuildEndpointV1ConversationsConversationIdBuildsBuildIdCancelPostApiResponse, CancelBuildEndpointV1ConversationsConversationIdBuildsBuildIdCancelPostApiArg>({
            query: (queryArg) => ({
                url: `/v1/conversations/${queryArg.conversationId}/builds/${queryArg.buildId}/cancel`,
                method: "POST",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        listWorkflowBuildNotificationsEndpointV1WorkflowBuildNotificationsGet: build.query<ListWorkflowBuildNotificationsEndpointV1WorkflowBuildNotificationsGetApiResponse, ListWorkflowBuildNotificationsEndpointV1WorkflowBuildNotificationsGetApiArg>({
            query: (queryArg) => ({
                url: `/v1/workflow-build-notifications`,
                params: { limit: queryArg.limit, cursor: queryArg.cursor },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        updateWorkflowBuildNotificationEndpointV1WorkflowBuildNotificationsBuildIdPatch: build.mutation<UpdateWorkflowBuildNotificationEndpointV1WorkflowBuildNotificationsBuildIdPatchApiResponse, UpdateWorkflowBuildNotificationEndpointV1WorkflowBuildNotificationsBuildIdPatchApiArg>({
            query: (queryArg) => ({
                url: `/v1/workflow-build-notifications/${queryArg.buildId}`,
                method: "PATCH",
                body: queryArg.updateWorkflowBuildNotificationRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getEntitySummaryEndpointV1EntitySummariesEntityTypeEntityIdGet: build.query<GetEntitySummaryEndpointV1EntitySummariesEntityTypeEntityIdGetApiResponse, GetEntitySummaryEndpointV1EntitySummariesEntityTypeEntityIdGetApiArg>({
            query: (queryArg) => ({
                url: `/v1/entity-summaries/${queryArg.entityType}/${queryArg.entityId}`,
                params: { wait: queryArg.wait },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
    }),
    overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type HealthzHealthzGetApiResponse = 
/** status 200 Successful Response */ {
    [key: string]: string;
};
export type HealthzHealthzGetApiArg = void;
export type CreateConversationEndpointV1ConversationsPostApiResponse = 
/** status 201 Successful Response */ ConversationResponse;
export type CreateConversationEndpointV1ConversationsPostApiArg = {
    createConversationRequest: CreateConversationRequest;
};
export type ListConversationsEndpointV1ConversationsGetApiResponse = 
/** status 200 Successful Response */ ConversationListResponse;
export type ListConversationsEndpointV1ConversationsGetApiArg = {
    /** Page size. Defaults to 20 when omitted. */
    limit?: number;
    /** Omit this on the first request. For each page after that, send back the `next_cursor` value from the previous response, unchanged. Opaque: it is not a page number or a row offset, so do not parse or construct one. A cursor is tied to the query that produced it, so discard it whenever `workflow_id` changes and start again with no cursor. */
    cursor?: string | null;
    /** Return only the conversations bound to this workflow. Omit to list all of the caller's conversations. */
    workflowId?: string | null;
};
export type GetConversationEndpointV1ConversationsConversationIdGetApiResponse = 
/** status 200 Successful Response */ ConversationWithMessagesResponse;
export type GetConversationEndpointV1ConversationsConversationIdGetApiArg = {
    conversationId: string;
};
export type DeleteConversationEndpointV1ConversationsConversationIdDeleteApiResponse = 
/** status 204 Successful Response */ void;
export type DeleteConversationEndpointV1ConversationsConversationIdDeleteApiArg = {
    conversationId: string;
};
export type ListMessagesEndpointV1ConversationsConversationIdMessagesGetApiResponse = 
/** status 200 Successful Response */ MessageListResponse;
export type ListMessagesEndpointV1ConversationsConversationIdMessagesGetApiArg = {
    conversationId: string;
    /** Page size. Defaults to 50 when omitted. */
    limit?: number;
    /** Omit this on the first request. For each page after that, send back the `next_cursor` value from the previous response, unchanged. Opaque: it is not a page number or a row offset, so do not parse or construct one. */
    cursor?: string | null;
};
export type PostMessageEndpointV1ConversationsConversationIdMessagesPostApiResponse = 
/** status 200 Successful Response */ any;
export type PostMessageEndpointV1ConversationsConversationIdMessagesPostApiArg = {
    conversationId: string;
    accept?: string | null;
    "User-Timezone"?: string | null;
    createMessageRequest: CreateMessageRequest;
};
export type CreateFeedbackEndpointV1ConversationsConversationIdFeedbackPostApiResponse = 
/** status 201 Successful Response */ FeedbackResponse;
export type CreateFeedbackEndpointV1ConversationsConversationIdFeedbackPostApiArg = {
    conversationId: string;
    createFeedbackRequest: CreateFeedbackRequest;
};
export type CreateUploadEndpointV1ConversationsConversationIdUploadsPostApiResponse = 
/** status 202 Successful Response */ UploadResponse;
export type CreateUploadEndpointV1ConversationsConversationIdUploadsPostApiArg = {
    conversationId: string;
    bodyCreateUploadEndpointV1ConversationsConversationIdUploadsPost: BodyCreateUploadEndpointV1ConversationsConversationIdUploadsPost;
};
export type CreateBuildEndpointV1ConversationsConversationIdBuildsPostApiResponse = 
/** status 202 Successful Response */ BuildResponse;
export type CreateBuildEndpointV1ConversationsConversationIdBuildsPostApiArg = {
    conversationId: string;
    "User-Timezone"?: string | null;
    submitBuildRequest: SubmitBuildRequest;
};
export type GetBuildEndpointV1ConversationsConversationIdBuildsBuildIdGetApiResponse = 
/** status 200 Successful Response */ BuildSummary;
export type GetBuildEndpointV1ConversationsConversationIdBuildsBuildIdGetApiArg = {
    conversationId: string;
    buildId: string;
};
export type CancelBuildEndpointV1ConversationsConversationIdBuildsBuildIdCancelPostApiResponse = 
/** status 200 Successful Response */ BuildSummary;
export type CancelBuildEndpointV1ConversationsConversationIdBuildsBuildIdCancelPostApiArg = {
    conversationId: string;
    buildId: string;
};
export type ListWorkflowBuildNotificationsEndpointV1WorkflowBuildNotificationsGetApiResponse = 
/** status 200 Successful Response */ WorkflowBuildNotificationListResponse;
export type ListWorkflowBuildNotificationsEndpointV1WorkflowBuildNotificationsGetApiArg = {
    /** Page size. Defaults to 20 when omitted. */
    limit?: number;
    /** Omit this on the first request. For each page after that, send back the `next_cursor` value from the previous response, unchanged. Opaque: it is not a page number or a row offset, so do not parse or construct one. */
    cursor?: string | null;
};
export type UpdateWorkflowBuildNotificationEndpointV1WorkflowBuildNotificationsBuildIdPatchApiResponse = 
/** status 200 Successful Response */ WorkflowBuildNotification;
export type UpdateWorkflowBuildNotificationEndpointV1WorkflowBuildNotificationsBuildIdPatchApiArg = {
    buildId: string;
    updateWorkflowBuildNotificationRequest: UpdateWorkflowBuildNotificationRequest;
};
export type GetEntitySummaryEndpointV1EntitySummariesEntityTypeEntityIdGetApiResponse = 
/** status 200 A summary is stored and is fresh enough to show. */ EntitySummaryResponse | /** status 202 No summary is available yet. One is being generated; poll this endpoint again. */ void;
export type GetEntitySummaryEndpointV1EntitySummariesEntityTypeEntityIdGetApiArg = {
    entityType: string;
    entityId: string;
    /** Seconds to wait for a summary that is still being generated, instead of returning 202 immediately. Clamped to the server's own ceiling. A wait that expires returns 202, not an error, so a client can always fall back to polling. */
    wait?: number;
};
export type ConversationResponse = {
    id: string;
    client_id: number;
    user_id: number;
    title: string;
    created_at: string;
    updated_at: string;
    workflow_id?: string | null;
};
export type ValidationError = {
    loc: (string | number)[];
    msg: string;
    type: string;
    input?: any;
    ctx?: object;
};
export type HttpValidationError = {
    detail?: ValidationError[];
};
export type CreateConversationRequest = {
    title?: string;
};
export type ConversationListItem = {
    id: string;
    title: string;
    created_at: string;
    updated_at: string;
    last_message_at?: string | null;
    workflow_id?: string | null;
};
export type ConversationListResponse = {
    /** The page size that was applied to this response. */
    limit: number;
    /** Opaque token for the page AFTER this one, or null when this is the last page. Send it back unchanged in the `cursor` query parameter to get the next page. It is not a page number and not a row offset: treat it as a meaningless string, and never parse, construct, or increment it. */
    next_cursor?: string | null;
    conversations: ConversationListItem[];
};
export type MessageResponse = {
    id: string;
    conversation_id: string;
    client_id: number;
    sequence: number;
    role: string;
    content: string;
    structured_data?: {
        [key: string]: any;
    } | null;
    trace_id: string;
    created_at: string;
};
export type BuildResultStepProjection = {
    step?: string | null;
    status?: string | null;
    error?: string | null;
};
export type BuildResultProjection = {
    schema_version?: number | null;
    status?: string | null;
    workflow_id?: string | null;
    summary?: string | null;
    error?: string | null;
    steps?: BuildResultStepProjection[] | null;
};
export type BuildSummary = {
    id: string;
    conversation_id: string;
    request_message_id: string;
    result_message_id?: string | null;
    status: string;
    workflow_id?: string | null;
    error?: string | null;
    result?: BuildResultProjection | null;
    created_at: string;
    updated_at: string;
};
export type ConversationWithMessagesResponse = {
    conversation: ConversationResponse;
    messages: MessageResponse[];
    builds?: BuildSummary[];
};
export type MessageListResponse = {
    /** The page size that was applied to this response. */
    limit: number;
    /** Opaque token for the page AFTER this one, or null when this is the last page. Send it back unchanged in the `cursor` query parameter to get the next page. It is not a page number and not a row offset: treat it as a meaningless string, and never parse, construct, or increment it. */
    next_cursor?: string | null;
    messages: MessageResponse[];
};
export type CreateMessageRequest = {
    content: string;
    context?: {
        [key: string]: any;
    };
    workflow_id?: string | null;
};
export type FeedbackResponse = {
    id: string;
};
export type CreateFeedbackRequest = {
    message_id: string;
    rating: string;
    text?: string | null;
};
export type UploadResponse = {
    upload_id: string;
    conversation_id: string;
    scan_status: string;
    file_name?: string | null;
};
export type BodyCreateUploadEndpointV1ConversationsConversationIdUploadsPost = {
    file: string;
};
export type BuildResponse = {
    build_id: string;
    conversation_id: string;
    status: string;
    trace_id: string;
};
export type SubmitBuildRequest = {
    prompt?: string;
    upload_ids?: string[];
    workflow_id?: string | null;
    explicit_operation?: ("create" | "clone") | null;
    source_workflow_ref?: string | null;
};
export type WorkflowBuildNotification = {
    build_id: string;
    conversation_id: string;
    status: string;
    workflow_id?: string | null;
    error?: string | null;
    read_at?: string | null;
    dismissed_at?: string | null;
    created_at: string;
    updated_at: string;
};
export type WorkflowBuildNotificationListResponse = {
    /** The page size that was applied to this response. */
    limit: number;
    /** Opaque token for the page AFTER this one, or null when this is the last page. Send it back unchanged in the `cursor` query parameter to get the next page. It is not a page number and not a row offset: treat it as a meaningless string, and never parse, construct, or increment it. */
    next_cursor?: string | null;
    notifications: WorkflowBuildNotification[];
};
export type UpdateWorkflowBuildNotificationRequest = {
    read?: boolean | null;
    dismissed?: boolean | null;
};
export type EntitySummaryBody = {
    headline?: string;
    current_state?: string;
    what_is_done?: string[];
    what_is_next?: string[];
    blockers?: string[];
    key_facts?: {
        [key: string]: string;
    };
};
export type EntitySummaryResponse = {
    entity_type: string;
    entity_id: string;
    status: "ready" | "generating" | "unavailable";
    summary?: EntitySummaryBody | null;
    schema_version?: number;
    generated_at?: string | null;
    generated_at_epoch?: number | null;
    age_seconds?: number | null;
    refreshing?: boolean;
    detail?: string;
    last_failure_code?: string;
    failed_attempts?: number;
    trace_id?: string;
};
